module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/148-madeira-08d2d820c39cfdd2c8547bd022839a2e.svg";